import { render, staticRenderFns } from "./DocPlantUML.vue?vue&type=template&id=6f51ee87"
import script from "./DocPlantUML.vue?vue&type=script&lang=js"
export * from "./DocPlantUML.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports